import Vue from 'vue';
import { queuetonAPI } from "../../api/queuetonAPI";

const resourceId = (type, id) => `${type}__${id}`;

const state = {
  resourceInformationById: {},
  resourceIds: [],
  timer: {
    running: false,
    id: 0,
  },
};

const mutations = {
  UPDATE_RESOURCE_STATUS(state, { status, id, type }) {
    const internalResourceId = resourceId(type, id);

    if (!state.resourceInformationById[internalResourceId]) {
      return;
    }

    state.resourceInformationById[internalResourceId].status = status;
  },
  ADD_RESOURCE(state, { type, id, status }) {
    const internalResourceId = resourceId(type, id);

    if (! state.resourceInformationById[internalResourceId]) {
      Vue.set(state.resourceInformationById, internalResourceId, {
        listeners: 0, status, type, id
      });
    }

    state.resourceInformationById[internalResourceId].listeners += 1;
    state.resourceIds = [...new Set([...state.resourceIds, internalResourceId])];
  },
  REMOVE_RESOURCE(state, { type, id }) {
    const internalResourceId = resourceId(type, id);

    if (state.resourceInformationById[internalResourceId]) {
      if (state.resourceInformationById[internalResourceId].listeners > 1) {
        state.resourceInformationById[internalResourceId].listeners -= 1;
      } else {
        state.resourceIds = state.resourceIds.filter(id => internalResourceId !== id);
        delete state.resourceInformationById[internalResourceId];
      }
    }
  },
  UPDATE_RESOURCE_STATUSES(state, resources) {
    (resources || []).forEach(resource => {
      const internalResourceId = resourceId(resource['type'], resource['id']);
      state.resourceInformationById[internalResourceId].status = resource['status'];
    });
    return state;
  },
  UPDATE_TIMER(state, { running, id }) {
    state.timer.running = running;
    state.timer.id = id;
  }
};

const actions = {
  runTimer({ commit, dispatch, state }) {
    if (state.timer.running && state.timer.id) {
      return;
    }

    const timerId = setTimeout(() => dispatch('timerEventLoop'), 2000);
    commit('UPDATE_TIMER', { running: true, id: timerId });
  },
  killTimer({ commit, state }) {
    clearTimeout(state.timer.id);
    commit('UPDATE_TIMER', { running: false, id: 0 });
  },
  async timerEventLoop({ state, commit, dispatch }) {
    if (state.resourceIds.length === 0) {
      dispatch('killTimer');
      return;
    }

    const resources = state.resourceIds.map(internalId => {
      const internalResource = state.resourceInformationById[internalId];
      return { type: internalResource.type, id: internalResource.id };
    });

    const api = await queuetonAPI.getStatuses(resources);

    commit('UPDATE_TIMER', { running: true, id: 0 });
    commit('UPDATE_RESOURCE_STATUSES', api.resources);
    dispatch('runTimer');
  },
  async addResource({ commit, state, dispatch }, { type, id }) {
    const status = await queuetonAPI.getStatus(type, id);
    commit('ADD_RESOURCE', { type, id, status });

    if (! state.timer.running) {
      dispatch('runTimer');
    }
  },
  async removeResource({ state, commit, dispatch }, { type, id }) {
    commit('REMOVE_RESOURCE', { type, id });
  },
  async updateResourceStatus({ commit }, { type, id }) {
    const status = await queuetonAPI.getStatus(type, id);
    commit('UPDATE_RESOURCE_STATUS', { type, id, status });
  }
};

const getters = {
  resourceStatusOrig: state => (type, id) => {
    let internalId = resourceId(type, id);

    if (!state.resourceInformationById[internalId]) {
      return 'waiting';
    }

    return state.resourceInformationById[internalId].status;

  }
};

export const queueton = { state, mutations, actions, getters, namespaced: true };